import axios from '@axios'

const route = 'system/config'
export default {
  namespaced: true,
  state: {
    issRate: 3.00, // valor padrão
  },
  getters: {
    getIssRate: state => state.issRate / 100, // retorna como decimal (0.03)
    getIssRatePercent: state => state.issRate, // retorna como porcentagem (3.00)
  },
  mutations: {
    SET_ISS_RATE(state, issRate) {
      state.issRate = issRate || 3.00
    },
  },
  actions: {

    storeOrUpdate(context, config) {
      return axios.post(route, config)
    },

    loadConfig(context) {
      return axios.get(route).then(response => {
        if (response.data && response.data.iss_rate) {
          context.commit('SET_ISS_RATE', response.data.iss_rate)
        }

        return response
      })
    },

    storeSmtp(context, smtp) {
      return axios.post(`${route}/smtp`, smtp)
    },
    destroySmtp(context, smtp) {
      return axios.delete(`${route}/smtp/${smtp.id}`)
    },

  },
}
